"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const web_consensus_1 = require("@branch-ts/web-consensus");
const defaultSize = 18;
function createTablerIconContent(option) {
    return () => {
        const parser = new DOMParser();
        const svgMarkup = [
            `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"`,
            ` viewBox="0 0 24 24" fill="none" stroke="currentColor"`,
            ` stroke-width="2" stroke-linecap="round" stroke-linejoin="round"`,
            ` class="${option.className}">`,
            option.body,
            `</svg>`,
        ].join("");
        const documentElement = parser.parseFromString(svgMarkup, "image/svg+xml").documentElement;
        return documentElement;
    };
}
function registerTablerIcon(option) {
    const content = createTablerIconContent({
        className: option.className,
        body: option.body,
    });
    web_consensus_1.IconLib.set(option.name, {
        content,
        size: defaultSize,
    });
}
registerTablerIcon({
    name: "omni-idps",
    className: "icon-tabler icon-tabler-message-circle",
    body: `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M8 9h8"/>
        <path d="M8 13h6"/>
        <path d="M12 21l-4 -4h-3a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-3z"/>
    `,
});
registerTablerIcon({
    name: "omni-probe",
    className: "icon-tabler icon-tabler-hexagon",
    body: `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M19.875 6.27c.7 .404 1.125 1.149 1.125 1.958v7.544c0 .809 -.425 1.554 -1.125 1.958l-6.75 3.89a2.25 2.25 0 0 1 -2.25 0l-6.75 -3.89a2.25 2.25 0 0 1 -1.125 -1.958v-7.544c0 -.809 .425 -1.554 1.125 -1.958l6.75 -3.89a2.25 2.25 0 0 1 2.25 0z"/>
    `,
});
registerTablerIcon({
    name: "omni-notification",
    className: "icon-tabler icon-tabler-bell",
    body: `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <g transform="translate(-1.2 -0.8) scale(1.1 1)">
            <path d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3l2 3h-16l2 -3v-3a7 7 0 0 1 4 -6"/>
            <path d="M9 17a3 3 0 0 0 6 0"/>
        </g>
    `,
});
registerTablerIcon({
    name: "omni-guild",
    className: "icon-tabler icon-tabler-chess-knight",
    body: `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <g transform="translate(3.96 0.26) scale(0.043125)">
            <path fill="currentColor" stroke="none" d="M352 224v224H32v-46.557c0-30.302 17.12-58.003 44.223-71.554l57.243-28.622A48 48 0 0 0 160 258.334V208l-22.127 11.063a23.996 23.996 0 0 0-12.55 15.645l-11.835 47.338a12 12 0 0 1-7.185 8.231l-29.601 11.84a11.998 11.998 0 0 1-9.33-.176L7.126 275.167A12 12 0 0 1 0 264.201v-158.26c0-6.365 2.529-12.47 7.03-16.971L16 80 1.789 51.578A16.937 16.937 0 0 1 0 44c0-6.627 5.373-12 12-12h148c106.039 0 192 85.961 192 192zm20 240H12c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12zM52 128c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"/>
        </g>
    `,
});
registerTablerIcon({
    name: "omni-profile",
    className: "icon-tabler icon-tabler-user-circle",
    body: `
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 12a3 3 0 1 0 0 -6a3 3 0 0 0 0 6"/>
        <path d="M6 18.5a6 6 0 0 1 12 0"/>
        <path d="M12 21a9 9 0 1 0 0 -18a9 9 0 0 0 0 18"/>
    `,
});
registerTablerIcon({
    name: "omni-ic",
    className: "icon-tabler icon-tabler-circle-dot",
    body: `
        <circle cx="12" cy="12" r="9.5"/>
        <circle cx="12" cy="12" r="2.5" fill="currentColor" stroke="none"/>
    `,
});
